export const proactiveDiscountPeriods = [{ startMonth: 2, startDay: 1, endMonth: 4, endDay: 1 }, { startMonth: 9, startDay: 1, endMonth: 11, endDay: 1 }] // Months are zero-based; 3/1 - 5/1 or 10/1 - 12/1
export const neededDatePeriodDays = 90
export const defaultAmountShipping = 0.00 // 35.00
export const federalExciseTaxRate = .11
export const flatDiscount200 = ['X2ODG-BK', 'X2ODG-SL', 'X2BK-BK', 'X2BK-SL', 'X2CRBK-BK', 'X2CRBK-SL', 'X2CRODG-BK', 'X2CRODG-SL', 'X2-CM', 'X2CM-BK', 'X2TCM-BK', 'X2TCM-CM', 'X2CRTCM', 'IX2BK-BK', 'IX2BK-SL', 'IX2CRBK-BK', 'IX2CRBK-SL', 'IX2CRTCM', 'IX2TCM-BK', 'IX2TCM-CM']
export const flatDiscount300 = ['XCALCM', 'XCALBK', 'XCALTCM', 'IXCALBK', 'IXCALTCM', 'XCALBKL', 'IXCALBKL', 'XCALTCML', 'IXCALTCML']
export const caseSizes = () => {
  let caseCounts =[15, 25, 30]
  for (let i = 40; i <= 3500; i += 5) {
    caseCounts.push(i)
  }
  return caseCounts
}